var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "brb-input",
        _vm._b(
          {
            attrs: { label: _vm.label, id: _vm.id, dir: "ltr" },
            model: {
              value: _vm.model,
              callback: function ($$v) {
                _vm.model = $$v
              },
              expression: "model",
            },
          },
          "brb-input",
          _vm.$attrs,
          false
        )
      ),
      _c("date-picker", {
        class: { hour: _vm.type === "hour" },
        attrs: {
          type: _vm.computedType,
          element: _vm.id,
          min: _vm.computedMin,
          max: _vm.computedMax,
          "auto-submit": _vm.autoSubmit,
          color: _vm.color,
          simple: _vm.simple,
          "use-router": "",
        },
        on: {
          input: function ($event) {
            _vm.$emit("input", _vm.createModelOut($event))
          },
        },
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }